import Vue from 'vue'
import Model from './model.vue'

const ImgManagerConstructor = Vue.extend(Model)

function insectManager(options = {}, onClose) {
  if (typeof onClose === 'function') {
    options.onClose = onClose
  }

  const instance = new ImgManagerConstructor({
    propsData: options
  })

  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.vm.visible = true
}

export default insectManager
